var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":_vm.color}}),_c('p',{staticClass:"mt-3"},[_vm._v(_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }